/*
  LUMINANTE — Luminante en vidéo.

  Le lecteur est le lecteur NATIF du navigateur (attribut controls,
  demande d'Antho du 06/09) : lecture, pause, son, plein écran sont ses
  commandes, rien n'est réécrit. Les <video> naissent en preload="none"
  avec leur poster : pas un octet téléchargé avant que le visiteur ne
  lance lui-même une vidéo.

  Il pose aussi les images d'attente (data-lum-poster) a l'approche de la
  section : l'attribut `poster` natif n'a pas de mode lazy et faisait
  telecharger 215 Ko des le premier rendu, sur une section situee tout en
  bas de la fiche.

  Ce script n'ajoute que deux garde-fous :
  - une seule vidéo joue à la fois : en lancer une met les autres en pause ;
  - une vidéo qui sort entièrement de l'écran, ou un onglet passé en
    arrière-plan, se met en pause. Aucune reprise automatique.

  Ni bibliothèque, ni écouteur de scroll.
*/
(function () {
  var PRET = 'lumVideosPret';

  function init(section) {
    if (section.dataset[PRET] === 'oui') return;
    section.dataset[PRET] = 'oui';

    var videos = Array.prototype.slice.call(section.querySelectorAll('video[data-lum-video]'));
    if (!videos.length) return;

    /* Image d'attente posee seulement a l'approche. Sans
       IntersectionObserver, on la pose tout de suite : mieux vaut le
       comportement d'avant que pas d'image du tout. */
    function poser(video) {
      var url = video.getAttribute('data-lum-poster');
      if (!url) return;
      video.poster = url;
      video.removeAttribute('data-lum-poster');
    }

    if ('IntersectionObserver' in window) {
      var vigie = new IntersectionObserver(
        function (entrees) {
          entrees.forEach(function (e) {
            if (!e.isIntersecting) return;
            poser(e.target);
            vigie.unobserve(e.target);
          });
        },
        { rootMargin: '400px 0px' }
      );
      videos.forEach(function (v) {
        vigie.observe(v);
      });
    } else {
      videos.forEach(poser);
    }

    videos.forEach(function (v) {
      v.addEventListener('play', function () {
        videos.forEach(function (autre) {
          if (autre !== v && !autre.paused) autre.pause();
        });
      });
    });

    if ('IntersectionObserver' in window) {
      var observateur = new IntersectionObserver(
        function (entrees) {
          entrees.forEach(function (e) {
            if (!e.isIntersecting && !e.target.paused) e.target.pause();
          });
        },
        { threshold: 0 }
      );
      videos.forEach(function (v) {
        observateur.observe(v);
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        videos.forEach(function (v) {
          if (!v.paused) v.pause();
        });
      }
    });
  }

  function tout() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lum-videos]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tout);
  } else {
    tout();
  }

  // Éditeur de thème : la section est re-rendue à chaque réglage.
  document.addEventListener('shopify:section:load', tout);
})();
